import { AppProviders, LibraryProviders } from "web/Providers"
import { BrowserRouter as Router } from "react-router-dom"
import { Controller } from "@hotwired/stimulus"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditComparableDealAsset,
} from "web/components"
import { render } from "react-dom"
import { TLOContextProvider } from "web/contexts"
import { useComparableDealAsset } from "web/hooks/data"
import React, { Suspense } from "react"

export default class ComparableDealAssetViewOrEditTLOController extends Controller {
  static values = {
    comparableDealAssetId: Number,
    excludedFieldIds: Array,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const ComparableDealAssetTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType="sale_asset"
          data={useComparableDealAsset(this.comparableDealAssetIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <ComparableDealAssetTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditComparableDealAsset
                    excludedFieldIds={this.excludedFieldIdsValue}
                  />
                </ErrorBoundary>
              </ComparableDealAssetTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
